import { Fragment, useId } from 'react';
import { useFormContext, type FieldError as FieldErrorType } from 'react-hook-form';
import formStyles from '~/styles/form.module.css';
import getWithDot from '~/helpers/getWithDot';
import cnh from '~/helpers/cnh';
import FormLabel from './FormLabel';
import FieldError from './FieldError';

type Props = {
  label: string
  items: {
    key: string;
    label: string;
  }[];
  registerField: string;
  required?: boolean;
};

export default function Radio({
  label,
  items,
  registerField,
  required = false,
}: Props) {
  const radiosId = useId();
  const { register, formState: { errors } } = useFormContext();

  const errorForField = getWithDot<FieldErrorType>(registerField, errors);

  return (
    <div>
      <FormLabel required={required}>
        {label}
      </FormLabel>

      <div className={formStyles.radioLabels}>
        {items.map((item) => (
          <Fragment key={item.key}>
            <input
              className={cnh(
                formStyles.formCheckbox,
                errorForField ? formStyles.formCheckboxInvalid : '',
              )}
              type="radio"
              value={item.key}
              id={`${radiosId}-${item.key}`}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...register(registerField, { required })}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label
              key={item.key}
              htmlFor={`${radiosId}-${item.key}`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: item.label,
              }}
            />
          </Fragment>
        ))}
      </div>

      {errorForField && (
        <FieldError error={errorForField} />
      )}
    </div>
  );
}
